

























































































































































import { Component } from 'vue-property-decorator';
import { AuthModule } from '@/store/Auth/AuthModule';
import { AppModule } from '@/store/Auth/AppModule';
import { InstitutionsModule } from '@/store/Settings/InstitutionsModule';
import UserProfileMenu from '@/components/Dashboard/Profile/UserProfileMenu.vue';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import PermissionType from '@/models/Settings/Roles/PermissionType';
import PermissionUtils from '@/lib/permissionUtils';
import { LOCALES } from "@/i18n/locales";
import { defaultLocale } from "@/i18n";
import FeatureToggleCode from "@/models/Settings/Institutions/FeatureToggleCode";

@Component({ name: 'LoggedInLayout', components: { UserProfileMenu } })
export default class extends SaascadaVue {

    PermissionUtils = PermissionUtils;
    FeatureToggleCode = FeatureToggleCode;
    defaultLocaleOption = defaultLocale;
    locales = LOCALES;
    // Initialise menu state based on the previously saved state (same process as portal settings)
    menuIsOpen: boolean = localStorage.getItem("saascada-menu-is-closed") ? false : true;

    async beforeMount() {
        // Note that this will rebuild the navigation menu every time the page refreshes (if logged in)
        await AppModule.setNavigationMenu();
        // The below calls will happen every time the page refreshes, we do this on purpose here
        // because the data for them is used everywhere and will always be needed (e.g currency)
        // and doing it once here saves having to redo it in every component
        await AuthModule.getMe();
        await InstitutionsModule.getInstitutionLoggedIn(this.institutionId);
    }

    async openKnowledgeBase() {
        // Open at the root page of the docs
        await AppModule.openExternalDocumentationURL("/");
    }

    get institutionId() {
        return AuthModule.me.institution.id;
    }

    get institutionName() {
        return AuthModule.me.institution.name;
    }

    get navigationMenu() {
        return AppModule.navigationMenu;
    }

    toggleMenuIsOpen() {
        if (this.menuIsOpen) {
            localStorage.setItem("saascada-menu-is-closed", "YES");
            this.menuIsOpen = false;
        }
        else {
            localStorage.removeItem("saascada-menu-is-closed");
            this.menuIsOpen = true;
        }
    }

    showAccountsGroup() {
        if (PermissionUtils.hasPermission(PermissionType.ThirdPartyAccountsRead) ||
            PermissionUtils.hasPermission(PermissionType.InstitutionalAccountsRead) ||
            PermissionUtils.hasPermission(PermissionType.DepositAccountsRead) ||
            PermissionUtils.hasPermission(PermissionType.LendingAccountsRead)) {
            return true;
        }
        return false;
    }

    showCustomersGroup() {
        // Must have access to the UX API to be able to see the customers group in the menu
        if (AuthModule.me.institution.config.uxApiAccess && PermissionUtils.allowUxApiAccess()) {
            return true;
        }
        return false;
    }

    showSettingsGroup() {
        return (PermissionUtils.hasPermission(PermissionType.UsersRead) ||
                PermissionUtils.hasPermission(PermissionType.RolesRead) ||
                PermissionUtils.hasPermission(PermissionType.AppMediumsRead) ||
                PermissionUtils.hasPermission(PermissionType.WebhooksRead) ||
                PermissionUtils.hasPermission(PermissionType.InstitutionSettingsRead));
    }

    showAccountingGroup() {
        if (PermissionUtils.hasPermission(PermissionType.AccountingRead) && PermissionUtils.isFeatureToggleEnabled(FeatureToggleCode.GeneralLedger)) {
            return true;
        }
        return false;
    }

    showReportingGroup() {
        if (PermissionUtils.hasPermission(PermissionType.ReportsRead)) {
            return true;
        }
        return false;
    }

};
